import SmileyTestPage from '@/components/help-center/SmileyTestPage';

export default function SmileyTestRoutePage() {
  return <SmileyTestPage />;
}
